var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personalizedType !== 'clipartCategory')?_c('FormulateInput',{attrs:{"name":_vm.layer.id,"label":_vm.label,"layer":_vm.layer,"configsMoonPhase":_vm.configsMoonPhase,"type":"imagemoonphase","artwork":_vm.artwork,"aspectRatio":_vm.aspectRatio},on:{"changeTextMoonPhase":_vm.ChangeTextMoonPhase}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4210ed22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ImageMoonPhaseField.vue
// module id = 237
// module chunks = 0